import axios from "axios";

export const fetchGetJobDetail = async (jobId: string) => {
  return axios.get(`/api/company/job/${jobId}`);
};
